// Alle state-providers in de juiste volgorde:
// Toast (gebruikt door iedereen) → Activities → Prefs → Logs → Weather → Timer (heeft Logs + Activities + Toast nodig).
import type { ReactNode } from 'react';
import { ActivitiesProvider } from './ActivitiesProvider';
import { LogsProvider } from './LogsProvider';
import { PrefsProvider } from './PrefsProvider';
import { TimerProvider } from './TimerProvider';
import { ToastProvider } from './ToastProvider';
import { WeatherProvider } from './WeatherProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <ActivitiesProvider>
        <PrefsProvider>
          <LogsProvider>
            <WeatherProvider>
              <TimerProvider>{children}</TimerProvider>
            </WeatherProvider>
          </LogsProvider>
        </PrefsProvider>
      </ActivitiesProvider>
    </ToastProvider>
  );
}

export { useActivities } from './ActivitiesProvider';
export { useLogs } from './LogsProvider';
export { useTimer } from './TimerProvider';
export { usePrefs } from './PrefsProvider';
export { useToast, useToastLayout } from './ToastProvider';
export { useWeather } from './WeatherProvider';
